import { useState } from "react";
import { useDispatch } from "react-redux";
import {
    requestCategories as creatorsCategories,
    requestBrands as creatorsBrands,
    requestModels as creatorsModels,
    requestYears as creatorsYears,
} from "@/redux/ducks/customer";

export interface VehiclesInfos {
    brands?: {
        text: string;
        value: number;
    }[];
    models?: {
        text: string;
        value: number;
    }[];
    axles?: {
        text: string;
        value: number;
    }[];
    years?: {
        text: string;
        value: number;
    }[];
}

const useVehicles: () => {
    data: null | {
        [key: string]: unknown;
    } & VehiclesInfos;
    requestBrands: (type: string) => void;
    requestModels: (type: string, brandId: string) => void;
    requestYears: (modelId: string, brandId: string) => void;
    requestCategories: (typeId: string, modelId: string, brandId: string) => void;
    setData: (name: string, value: unknown) => void
    isLoadingOrdering: boolean;
} = () => {
    const dispatch = useDispatch();
    
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<null | {
        [key: string]: unknown;
    }>(null);

    const handleSetData = (name: string, value: unknown) => {
        setData(data => ({
            ...data,
            [name]: value,
        }));
    }

    const handleRequestCategories = (success: boolean, data: null | { id: string; name: string }[]) => {
        setIsLoading(false);

        if (!success) {
            handleSetData("axles", null);
            return;
        }

        handleSetData("axles", data);
    }

    const requestCategories = (typeId: string, modelId: string, brandId: string) => {
        if (isLoading) return;

        setIsLoading(true);
        
        dispatch(
            creatorsCategories({ typeId, modelId, brandId, callback: handleRequestCategories})
        );
    }

    const handleRequestYears = (success: boolean, data: null | { id: string; name: string }[]) => {
        setIsLoading(false);

        if (!success) {
            handleSetData("years", null);
            return;
        }

        handleSetData("years", data);
    }

    const requestYears = (modelId: string, brandId: string) => {
        if (isLoading) return;

        setIsLoading(true);
        
        dispatch(creatorsYears({ modelId, brandId, callback: handleRequestYears}));
    }

    const handleRequestModels = (success: boolean, data: null | { id: string; name: string }[]) => {
        setIsLoading(false);

        if (!success) {
            handleSetData("models", null);
            return;
        }

        handleSetData("models", data);
    }

    const requestModels = (type: string, brandId: string) => {
        if (isLoading) return;

        setIsLoading(true);
        
        dispatch(creatorsModels({ type, brandId, callback: handleRequestModels}));
    }

    const handleRequestBrands = (success: boolean, data: null | { id: string; name: string }[]) => {
        setIsLoading(false);

        if (!success) {
            handleSetData("brands", null);
            return;
        }
        
        handleSetData("brands", data);
    }

    const requestBrands = (type: string) => {
        if (isLoading) return;

        setIsLoading(true);

        dispatch(creatorsBrands({ type, callback: handleRequestBrands}));
    }

    return {
        data,
        requestBrands,
        requestModels,
        requestYears,
        setData: handleSetData,
        requestCategories,
        isLoadingOrdering: isLoading,
    }
}

export default useVehicles;